import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

// Models
import { ActorCreateModel, ActorModel } from '@app/models/actor.model';
import { ApiService } from '../api/api.service';
import { Motivation } from '@app/enums/motivation';

// Services

@Injectable({
  providedIn: 'root',
})
export class ActorService {
  private readonly apiService = inject(ApiService);
  private readonly baseUrl = 'actors/';

  public search(actorName: string): Observable<ActorModel[]> {
    const resourceUrl = `search/${actorName}`;

    return this.apiService.getJson<ActorModel[]>(this.baseUrl + resourceUrl);
  }

  public nameExists(actorName: string): Observable<boolean> {
    const resourceUrl = `nameExists/${actorName}`;

    return this.apiService.getJson<boolean>(this.baseUrl + resourceUrl);
  }

  public create(actorData: ActorCreateModel): Observable<ActorModel> {
    const resourceUrl = `create`;

    return this.apiService.post<ActorModel>(this.baseUrl + resourceUrl, JSON.stringify({ ...actorData }));
  }

  public getMotivationByThreatActor(actorName: string): Observable<Motivation> {
    const resourceUrl = `getMotivation/${actorName}`;

    return this.apiService.getJson<Motivation>(this.baseUrl + resourceUrl);
  }
}
